'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  color: ', ';\n\n  ', ':checked ~ ', ' {\n    ', ' {\n      background-color: ', ';\n      border: 2px solid ', ';\n      box-shadow: inset 0 0 0 2px ', ';\n    }\n  }\n  \n  &:hover {\n    ', ':not(:checked) ~ ', ' {\n      ', ' {\n        background-color: ', ';\n        box-shadow: inset 0 0 0 2px ', ';\n      }\n    }\n  }\n\n  ', ' {\n    cursor: ', ';\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  color: ', ';\n\n  ', ':checked ~ ', ' {\n    ', ' {\n      background-color: ', ';\n      border: 2px solid ', ';\n      box-shadow: inset 0 0 0 2px ', ';\n    }\n  }\n  \n  &:hover {\n    ', ':not(:checked) ~ ', ' {\n      ', ' {\n        background-color: ', ';\n        box-shadow: inset 0 0 0 2px ', ';\n      }\n    }\n  }\n\n  ', ' {\n    cursor: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../config.js');

var _Button = require('./components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Input = require('./components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Label = require('./components/Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$isDisabled ? _config.colors.darkGray : _config.colors.black;
}, /* sc-selector */_Input2.default, /* sc-selector */_Label2.default, /* sc-selector */_Button2.default, function (props) {
  return props.$isDisabled ? _config.colors.darkGray : _config.colors.red;
}, _config.colors.gray, _config.colors.white, /* sc-selector */_Input2.default, /* sc-selector */_Label2.default, /* sc-selector */_Button2.default, function (props) {
  return props.$isDisabled ? _config.colors.white : _config.colors.lightGray;
}, _config.colors.white, _Label2.default, function (props) {
  return props.$isDisabled ? 'default' : 'pointer';
});

Wrapper.displayName = 'Wrapper';

/**
# Radio Button
A basic radio button
 */
var RadioButton = function RadioButton(_ref) {
  var label = _ref.label,
      value = _ref.value,
      name = _ref.name,
      id = _ref.id,
      isChecked = _ref.isChecked,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      restProps = _objectWithoutProperties(_ref, ['label', 'value', 'name', 'id', 'isChecked', 'onChange', 'disabled']);

  return _react2.default.createElement(
    Wrapper,
    _extends({
      $isDisabled: disabled
    }, restProps),
    _react2.default.createElement(_Input2.default, {
      disabled: disabled,
      type: 'radio',
      id: id,
      value: value,
      name: name,
      checked: isChecked,
      onChange: onChange
    }),
    _react2.default.createElement(
      _Label2.default,
      {
        htmlFor: id,
        role: 'presentation'
      },
      _react2.default.createElement(_Button2.default, null),
      label
    )
  );
};

RadioButton.propTypes = {
  /** Whether the radio button is disabled */
  disabled: _propTypes2.default.bool,
  /** The user-friendly label */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  /** A value to submit */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  /** An ID for the radio button */
  id: _propTypes2.default.string.isRequired,
  /** Whether the radio button is checked */
  isChecked: _propTypes2.default.bool.isRequired,
  /** A function to handle updates */
  onChange: _propTypes2.default.func.isRequired,
  /** A name to submit with the value */
  name: _propTypes2.default.string.isRequired
};

RadioButton.displayName = 'RadioButton';

exports.default = RadioButton;
RadioButton.__docgenInfo = {
  'description': '# Radio Button\r\nA basic radio button',
  'methods': [],
  'displayName': 'RadioButton',
  'props': {
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the radio button is disabled'
    },
    'label': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }]
      },
      'required': true,
      'description': 'The user-friendly label'
    },
    'value': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }, {
          'name': 'bool'
        }]
      },
      'required': true,
      'description': 'A value to submit'
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'An ID for the radio button'
    },
    'isChecked': {
      'type': {
        'name': 'bool'
      },
      'required': true,
      'description': 'Whether the radio button is checked'
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'A function to handle updates'
    },
    'name': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'A name to submit with the value'
    }
  }
};